<!-- Price Discovery Results Page -->
<div class="pd-page"
    [class.has-cart-bar]="hasCartItems">

    <div class="pd-container">
        <!-- Mobile Menu Toggle Button -->
        <button class="mobile-menu-toggle"
            (click)="toggleMobileSidebar()"
            *ngIf="isMobileView">
            <i class="material-icons">{{ isSidebarOpen ? 'close' : 'menu' }}</i>
            <span>{{ isSidebarOpen ? 'Close' : 'Search History' }}</span>
        </button>

        <!-- Sidebar Overlay for Mobile -->
        <div class="sidebar-overlay"
            *ngIf="isSidebarOpen && isMobileView"
            (click)="toggleMobileSidebar()"></div>

        <!-- Left Sidebar -->
        <aside class="pd-sidebar"
            [class.mobile-open]="isSidebarOpen">
            <!-- Mobile Close Button -->
            <button class="sidebar-close-btn"
                *ngIf="isMobileView"
                (click)="toggleMobileSidebar()">
                <i class="material-icons">close</i>
            </button>

            <!-- Add Best Matches Button -->
            <button class="sidebar-best-match-btn"
                *ngIf="searchItems.length > 0 && !isFavViewMode"
                [disabled]="isAnyItemLoading || (isDemoSearchMode && !enableLocalSupplier)"
                (click)="openBestMatchPopup()">
                Add Best Matches
            </button>

            <!-- Search Box -->
            <div class="topbar-search-box">
                <i class="material-icons search-icon">search</i>
                <input #searchInput
                    type="text"
                    placeholder="Search Items"
                    class="topbar-search-input"
                    [(ngModel)]="newItemSearchText"
                    (keyup.enter)="addNewSearchItem()"
                    (focus)="$event.target.select()">
                <button class="topbar-search-submit"
                    *ngIf="newItemSearchText"
                    (click)="addNewSearchItem()"
                    title="Search">
                    <i class="material-icons">search</i>
                </button>
                <div class="quick-add-wrapper"
                    *ngIf="!isPublicDemo">
                    <button class="topbar-lightning-btn"
                        (click)="toggleQuickAddMenu(); $event.stopPropagation()"
                        [class.active]="isQuickAddOpen"
                        [disabled]="isQuickAddLoading"
                        title="Quick Add">
                        <i class="material-icons">flash_on</i>
                    </button>
                    <div class="quick-add-backdrop"
                        *ngIf="isQuickAddOpen"
                        (click)="isQuickAddOpen = false"></div>
                    <div class="quick-add-dropdown"
                        *ngIf="isQuickAddOpen">
                        <span class="quick-add-label">Quick Add:</span>
                        <button class="quick-add-option"
                            *ngFor="let cat of quickAddCategories"
                            [class.active]="cat.active"
                            [disabled]="isQuickAddLoading"
                            (click)="onQuickAddClickFromMenu(cat)">
                            <i class="material-icons">{{ cat.icon }}</i>
                            <span>{{ cat.label }}</span>
                            <span class="quick-add-count"
                                *ngIf="cat.active && cat.addedItems.length > 0">{{ cat.addedItems.length }}</span>
                            <i class="material-icons quick-add-remove"
                                *ngIf="cat.active && cat.addedItems.length > 0"
                                (click)="removeQuickAddItems(cat); $event.stopPropagation()">close</i>
                        </button>
                    </div>
                </div>
            </div>

            <!-- Pending Search Tags (populated by quick add, searched on demand) -->
            <div class="pending-tags-area"
                *ngIf="pendingSearchTags.length > 0">
                <div class="pending-tags-list">
                    <span class="pending-tag"
                        *ngFor="let tag of pendingSearchTags">
                        {{ tag | titlecase }}
                        <i class="material-icons pending-tag-remove"
                            (click)="removePendingTag(tag)">close</i>
                    </span>
                </div>
                <button class="pending-search-btn"
                    (click)="searchPendingItems()">
                    <i class="material-icons">search</i>
                    Search ({{ pendingSearchTags.length }})
                </button>
            </div>

            <div class="sidebar-accordion-body"
                *ngIf="activeSidebarSection === 'recent'">
                <!-- Searched Items List -->
                <div class="search-items-list">
                    <div class="search-item"
                        *ngFor="let item of searchItems"
                        [class.active]="activeSearchItem === item.name"
                        (click)="selectSearchItem(item)">

                        <div class="search-item-img-container">
                            <img *ngIf="item.bestMatch?.image_url || item.bestMatch?.product_images; else placeholderImg"
                                [src]="item.bestMatch?.image_url || item.bestMatch?.product_images"
                                class="search-item-img"
                                onerror="this.src='assets/images/placeholder-product.svg'" />
                            <ng-template #placeholderImg>
                                <img src="assets/images/placeholder-product.svg"
                                    class="search-item-img" />
                            </ng-template>
                        </div>

                        <div class="search-item-info">
                            <span class="search-item-name"
                                [title]="item.name | titlecase">{{ item.name | titlecase }}</span>
                            <span class="search-item-price"
                                *ngIf="item.priceRange">{{ item.priceRange }}</span>
                            <span class="search-item-loading"
                                *ngIf="item.isLoading">Searching...</span>
                        </div>

                        <button class="remove-btn"
                            (click)="removeSearchItem(item); $event.stopPropagation()"
                            title="Remove">
                            <svg width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none">
                                <path d="M10.5 3.5L3.5 10.5M3.5 3.5L10.5 10.5"
                                    stroke="#E84F5A"
                                    stroke-width="1.5"
                                    stroke-linecap="round" />
                            </svg>
                        </button>
                    </div>
                </div>

                <!-- Multi Search Prompt Banner -->
                <div class="multi-search-prompt"
                    *ngIf="searchItems.length <= 1">
                    <div class="multi-search-illustration">
                        <img src="assets/images/multi-search-banner.png"
                            alt="Search Multiple Items" />
                    </div>
                    <!-- <h4 class="multi-search-title">You can Search Multiple Items</h4>
                <p class="multi-search-desc">Search several items and view all best prices together.</p> -->
                </div>
            </div>

            <!-- Fav Items Button -->
            <!-- Fav Items Button moved to main search bar -->
        </aside>

        <!-- Main Content -->
        <main class="pd-main"
            [class.has-cart-bar]="hasCartItems">
            <!-- Main Topbar: Back + Favourites + Sort -->
            <div class="main-topbar">
                <button class="topbar-back-btn"
                    (click)="goBack()">
                    <i class="material-icons">arrow_back</i>
                    <span>Back</span>
                </button>
                <div class="topbar-right">
                    <button class="topbar-fav-btn"
                        *ngIf="favProductsList.length > 0"
                        [class.active]="isFavViewMode"
                        [disabled]="isLoadingAllFav"
                        (click)="loadAllFavItems()"
                        title="View favorite items">
                        <span *ngIf="isLoadingAllFav"
                            class="fav-btn-spinner"></span>
                        <i *ngIf="!isLoadingAllFav"
                            class="material-icons">favorite</i>
                        <span>{{ isLoadingAllFav ? 'Searching...' : 'Favourites' }}</span>
                    </button>
                    <button class="topbar-inventory-pr-btn"
                        *ngIf="!isPublicDemo"
                        (click)="toggleInventoryPrModal()">
                        <i class="material-icons">inventory</i>
                        <span>Inventory PR</span>
                    </button>
                    <button class="topbar-hp-recent-btn"
                        *ngIf="!isPublicDemo && hyperpureStoreUuid"
                        (click)="toggleHpRecentPurchasesModal()">
                        <i class="material-icons">local_shipping</i>
                        <span>Recent Purchases</span>
                    </button>
                    <button class="topbar-sort-btn"
                        (click)="toggleSettingsPopup()"
                        title="Sort Suppliers">
                        <i class="material-icons">sort</i>
                        <span>Sort Suppliers</span>
                    </button>
                </div>
            </div>

            <div class="demo-unlock-banner"
                *ngIf="isDemoSearchMode && !isFavViewMode">
                <div class="demo-unlock-glow"
                    aria-hidden="true"></div>
                <div class="demo-unlock-icon"
                    aria-hidden="true">
                    <i class="material-icons">storefront</i>
                </div>
                <div class="demo-unlock-copy">
                    <h3>Unlock Better Supplier Pricing</h3>
                    <p>Compare prices from Hyperpure, DMart, Udaan &amp; DeliverIt — all in one place.</p>
                    <p>Connect with a supplier to start ordering, add items to Cart, or save them to Favourites.</p>
                    <div class="demo-unlock-suppliers"
                        aria-label="Supported suppliers">
                        <span class="demo-unlock-supplier-chip">
                            <img src="assets/images/hyperpure-logo.png"
                                alt="Hyperpure">
                        </span>
                        <span class="demo-unlock-supplier-chip">
                            <img src="assets/images/d-mart-logo.png"
                                alt="DMart">
                        </span>
                        <span class="demo-unlock-supplier-chip">
                            <img src="assets/images/udaan-logo.png"
                                alt="Udaan">
                        </span>
                        <span class="demo-unlock-supplier-chip">
                            <img src="assets/images/deliverIt.png"
                                alt="DeliverIt">
                        </span>
                    </div>
                </div>
                <button type="button"
                    class="demo-unlock-cta"
                    (click)="openConnectLeadPopup()">
                    <span>Connect Now</span>
                    <i class="material-icons">arrow_forward</i>
                </button>
            </div>

            <!-- Undo Market Best Items Button -->
            <div class="market-best-undo-bar"
                *ngIf="hasMarketBestItems">
                <div class="undo-info">
                    <svg width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none">
                        <path
                            d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"
                            fill="#f2c94c" />
                    </svg>
                    <span>{{ marketBestItemSkus.size }} Market Best {{ marketBestItemSkus.size === 1 ? 'item' : 'items'
                        }} added to cart</span>
                </div>
                <button class="undo-btn"
                    (click)="removeAllMarketBestItems()">
                    <svg width="14"
                        height="14"
                        viewBox="0 0 24 24"
                        fill="none">
                        <path
                            d="M12.5 8C9.85 8 7.45 9 5.6 10.6L2 7V16H11L7.38 12.38C8.77 11.22 10.54 10.5 12.5 10.5C16.04 10.5 19.05 12.81 20.1 16L22.47 15.22C21.08 11.03 17.15 8 12.5 8Z"
                            fill="currentColor" />
                    </svg>
                    <span>Undo All</span>
                </button>
            </div>

            <!-- Skeleton Loading State -->
            <div class="skeleton-container"
                *ngIf="isInitializing || isActiveItemLoading || isLoadingAllFav">

                <!-- Skeleton: Market Best Price Banner -->
                <div class="skeleton-banner"
                    *ngIf="!isFavViewMode">
                    <div class="skeleton-badge shimmer"></div>
                    <div class="skeleton-banner-content">
                        <div class="skeleton-banner-img shimmer"></div>
                        <div class="skeleton-banner-info">
                            <div class="skeleton-line w70 shimmer"></div>
                            <div class="skeleton-line w40 shimmer"></div>
                            <div class="skeleton-line w50 shimmer"></div>
                        </div>
                        <div class="skeleton-banner-price">
                            <div class="skeleton-line w60 shimmer"></div>
                            <div class="skeleton-btn shimmer"></div>
                        </div>
                    </div>
                </div>

                <!-- Skeleton: Supplier Section (repeat 2) -->
                <div class="skeleton-section"
                    *ngFor="let i of [1, 2]">
                    <div class="skeleton-section-header">
                        <div class="skeleton-logo shimmer"></div>
                        <div class="skeleton-line w30 shimmer"
                            style="margin-left: auto;"></div>
                    </div>
                    <div class="skeleton-cards-row">
                        <div class="skeleton-card"
                            *ngFor="let j of [1, 2, 3, 4, 5]">
                            <div class="skeleton-card-image shimmer"></div>
                            <div class="skeleton-card-body">
                                <div class="skeleton-line w80 shimmer"></div>
                                <div class="skeleton-line w50 shimmer"></div>
                                <div class="skeleton-card-footer">
                                    <div class="skeleton-line w40 shimmer"></div>
                                    <div class="skeleton-circle shimmer"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Market Best Price Banner (hidden in fav view mode) -->
            <div class="market-best-banner"
                *ngIf="marketBestPrice && !isInitializing && !isActiveItemLoading && !isFavViewMode">
                <div class="best-badge">MARKET BEST PRICE</div>
                <div class="best-content">
                    <img [src]="marketBestPrice.image_url || marketBestPrice.product_images || 'assets/images/placeholder-product.svg'"
                        alt=""
                        class="best-image"
                        onerror="this.src='assets/images/placeholder-product.svg'" />
                    <div class="best-info">
                        <h3 class="best-name">{{ marketBestPrice.item_name }}</h3>
                        <p class="best-supplier">From {{ resolveSupplierName(marketBestPrice.supplier) }}</p>
                        <div class="best-savings"
                            *ngIf="marketBestPrice.savings || marketBestPrice.savingsPercent">
                            <span class="savings-tag"
                                *ngIf="marketBestPrice.savings">{{ marketBestPrice.savings }}</span>
                            <span class="savings-percent"
                                *ngIf="marketBestPrice.savingsPercent">
                                {{ marketBestPrice.savingsPercent }}% lower than avg market rate
                            </span>
                        </div>
                    </div>
                    <div class="best-price-actions">
                        <div class="best-price">
                            <div>
                                <span class="price-amount">₹{{ marketBestPrice.rate.toFixed(2) }}</span>
                                <span class="price-unit">/{{ marketBestPrice.unit }}</span>
                            </div>
                            <span class="price-mrp"
                                *ngIf="marketBestPrice.mrp && marketBestPrice.mrp > marketBestPrice.rate">
                                ₹{{ marketBestPrice.mrp.toFixed(2) }}/{{ marketBestPrice.unit }}
                            </span>
                        </div>
                        <button class="add-to-cart-btn"
                            (click)="openBestPriceDrawer()"
                            [disabled]="isDemoPreviewSupplier(marketBestPrice.supplierId || marketBestPrice.originalSection?.id)"
                            [title]="isDemoPreviewSupplier(marketBestPrice.supplierId || marketBestPrice.originalSection?.id) ? demoDisabledActionTitle : 'Add to cart'">
                            <svg width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M7.4 17C6.84 17 6.4 17.44 6.4 18C6.4 18.56 6.84 19 7.4 19C7.96 19 8.4 18.56 8.4 18C8.4 17.44 7.96 17 7.4 17ZM17.4 17C16.84 17 16.4 17.44 16.4 18C16.4 18.56 16.84 19 17.4 19C17.96 19 18.4 18.56 18.4 18C18.4 17.44 17.96 17 17.4 17ZM15.9 14.5C16.65 14.5 17.29 14.07 17.6 13.43L20.8 7.64C20.89 7.47 20.9 7.28 20.9 7.1C20.9 6.55 20.45 6.1 19.9 6.1H6.62L5.68 4.1H2.4V6.1H4.4L8.01 13.68L6.72 16.03C6.49 16.44 6.4 16.92 6.4 17.43C6.4 18.3 7.12 19.03 8 19.03H19.4V17.03H8.42C8.28 17.03 8.16 16.91 8.16 16.77L8.2 16.62L9.31 14.6L15.9 14.5V14.5Z"
                                    fill="currentColor" />
                            </svg>
                            Add to Cart
                        </button>
                    </div>
                </div>
            </div>

            <!-- Supplier Sections -->
            <ng-container *ngFor="let section of supplierSections">
                <div class="supplier-section"
                    *ngIf="section.isVisible && (sectionHasActiveItems(section) || (isStandardSection(section.id) && section.id !== 'local')) && !isInitializing && !isActiveItemLoading && !isLoadingAllFav">
                    <!-- Section Header -->
                    <div class="section-header">
                        <div class="supplier-brand">
                            <!-- Hyperpure Logo -->
                            <ng-container *ngIf="section.id === 'hyperpure'">
                                <div class="brand-logo hyperpure-logo">
                                    <img src="assets/images/hyperpure-logo.png"
                                        alt="Hyperpure"
                                        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
                                    <span class="brand-fallback"
                                        style="display:none">hyperpure</span>
                                </div>
                            </ng-container>

                            <!-- DMart Logo -->
                            <ng-container *ngIf="section.id === 'dmart'">
                                <div class="brand-logo dmart-logo">
                                    <img src="assets/images/d-mart-logo.png"
                                        alt="DMart"
                                        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
                                    <span class="brand-fallback"
                                        style="display:none">D<span class="star">★</span>Mart</span>
                                </div>
                            </ng-container>

                            <!-- Udaan Logo -->
                            <ng-container *ngIf="section.id === 'udaan'">
                                <div class="brand-logo udaan-logo">
                                    <img src="assets/images/udaan-logo.png"
                                        alt="Udaan"
                                        onerror="this.style.display='none'; this.nextElementSibling.style.display='flex'" />
                                    <span class="brand-fallback"
                                        style="display:none">udaan</span>
                                </div>
                                <div class="udaan-promo-text">
                                    <img src="assets/images/udaan-promo-text.png"
                                        alt="Flat ₹500 off on first 5 Orders!" />
                                </div>
                            </ng-container>

                            <!-- Local Supplier Logo -->
                            <ng-container *ngIf="section.id === 'local'">
                                <div class="brand-logo local-logo">
                                    <img src="assets/images/local-suppliers-logo.png"
                                        alt="Local Suppliers" />
                                </div>
                            </ng-container>

                            <!-- Deliverit Logo -->
                            <ng-container *ngIf="section.id === 'deliverit'">
                                <div class="brand-logo local-logo mb-2">
                                    <img src="assets/images/deliverIt.png"
                                        alt="Local Suppliers" />
                                </div>
                            </ng-container>
                            <span class="demo-preview-chip"
                                *ngIf="isDemoPreviewSupplier(section.id)">Preview</span>
                        </div>

                        <div class="section-item-count"
                            *ngIf="sectionHasActiveItems(section)"
                            [class.clickable]="shouldShowViewAll(section)"
                            (click)="shouldShowViewAll(section) && openDrawer(section)">
                            <span>{{ getActiveTotalItems(section) }} Items</span>
                            <i class="material-icons view-all-arrow-icon"
                                *ngIf="shouldShowViewAll(section)">arrow_forward</i>
                        </div>
                    </div>

                    <!-- Product Cards Container -->
                    <div class="cards-container"
                        *ngIf="sectionHasActiveItems(section); else noItemsTemplate">
                        <div class="cards-row">
                            <div class="product-card"
                                [class.card-selected]="item.isSelected"
                                (click)="toggleCardSelection(item, $event)"
                                *ngFor="let item of getVisibleItems(section)">
                                <!-- Best Match Badge -->
                                <div class="badge best-match-badge"
                                    *ngIf="item.isBestMatch">
                                    <span class="star">★</span> BEST MATCH
                                </div>
                                <div class="badge best-value-badge"
                                    *ngIf="!item.isBestMatch && item.mrp && item.rate < item.mrp">
                                    <span class="star">★</span> BEST VALUE
                                </div>

                                <!-- Favourite Icon -->
                                <button class="fav-icon"
                                    [class.filled]="isSupplierProductFav(section.id, item)"
                                    [disabled]="isDemoPreviewSupplier(section.id)"
                                    (click)="toggleProductFavourite(item, section, $event)"
                                    [title]="isDemoPreviewSupplier(section.id) ? demoDisabledActionTitle : (isSupplierProductFav(section.id, item) ? 'Remove from favourites' : 'Add to favourites')">
                                    <svg width="18"
                                        height="18"
                                        viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.75L7.9125 14.7638C3.9 11.1113 1.125 8.58375 1.125 5.5125C1.125 2.985 3.0975 1.125 5.625 1.125C7.0425 1.125 8.4075 1.78875 9 2.82375C9.5925 1.78875 10.9575 1.125 12.375 1.125C14.9025 1.125 16.875 2.985 16.875 5.5125C16.875 8.58375 14.1 11.1113 10.0875 14.7638L9 15.75Z"
                                            [attr.stroke]="isSupplierProductFav(section.id, item) ? '#E91E63' : '#4CAF50'"
                                            stroke-width="1.2"
                                            [attr.fill]="isSupplierProductFav(section.id, item) ? '#E91E63' : 'none'" />
                                    </svg>
                                </button>

                                <!-- Product Image with Margin wrapper -->
                                <div class="image-margin">
                                    <div class="product-image">
                                        <img [src]="item.image_url || 'assets/images/placeholder-product.svg'"
                                            [alt]="item.item_name"
                                            onerror="this.src='assets/images/placeholder-product.svg'" />
                                    </div>
                                </div>

                                <!-- Product Info -->
                                <div class="product-info">
                                    <div class="product-details-container">
                                        <h4 class="product-name"
                                            [title]="item.item_name">{{ item.item_name }}</h4>
                                        <p class="product-pack">
                                            <svg width="12"
                                                height="12"
                                                viewBox="0 0 12 12"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0"
                                                    y="0"
                                                    width="12"
                                                    height="12"
                                                    rx="1"
                                                    stroke="#00A651"
                                                    stroke-width="1"
                                                    fill="none" />
                                                <circle cx="6"
                                                    cy="6"
                                                    r="3"
                                                    fill="#00A651" />
                                            </svg>
                                            {{ item.unit }}
                                        </p>
                                    </div>
                                    <p class="product-supplier"
                                        *ngIf="section.id === 'local' || item.supplierName || item.supplierId">
                                        <span class="supplier-link">{{ resolveSupplierName(item.supplierName || item.supplierId ||
                                            item.supplier) }}</span>
                                    </p>
                                    <div class="product-pricing">
                                        <div class="price-row">
                                            <div class="price-container">
                                                <div class="price-paragraph">
                                                    <span class="current-price">₹{{ item.rate.toFixed(2) }}</span>
                                                    <span class="mrp-price"
                                                        *ngIf="item.mrp && item.rate < item.mrp">₹{{ item.mrp.toFixed(2)
                                                        }}</span>
                                                </div>
                                                <div class="unit-price-container">
                                                    <div class="unit-price">₹{{ (item.rate / item.quantity).toFixed(0)
                                                        }}/{{
                                                        item.unit }}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Bulk Price Tiers -->
                                        <div class="bulk-label-wrapper"
                                            *ngIf="item.bulkPrices && item.bulkPrices.length > 0">
                                            <span class="bulk-label">
                                                <svg width="10"
                                                    height="10"
                                                    viewBox="0 0 16 16"
                                                    fill="none">
                                                    <path
                                                        d="M8 1C4.13 1 1 4.13 1 8s3.13 7 7 7 7-3.13 7-7-3.13-7-7-7zm.5 11h-1V7h1v5zm0-6.5h-1v-1h1v1z"
                                                        fill="#059669" />
                                                </svg>
                                                Bulk offer
                                            </span>
                                            <div class="bulk-tooltip">
                                                <div class="bulk-tooltip-title">Bulk Pricing</div>
                                                <div class="bulk-tooltip-row"
                                                    *ngFor="let bp of item.bulkPrices"
                                                    [class.active-tier]="isActiveBulkTier(item, bp)">
                                                    <span>Buy {{ bp.qty }}+</span>
                                                    <span class="bulk-tooltip-price">₹{{ bp.price }}/{{ item.unit
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Quantity Control (Absolute Positioned) -->
                                <div class="product-card-qty-control"
                                    *ngIf="item.selectedQuantity && item.selectedQuantity > 0; else productAddBtn">
                                    <div class="qty-loader"
                                        *ngIf="item.isAddingToCart">
                                        <div class="spinner"></div>
                                    </div>
                                    <ng-container *ngIf="!item.isAddingToCart">
                                        <button class="qty-btn-card"
                                            (click)="updateQuantity(item, -1); $event.stopPropagation()"
                                            [disabled]="item.isAddingToCart || isDemoPreviewSupplier(section.id)">-</button>
                                        <span class="qty-val-card">{{ item.selectedQuantity }}</span>
                                        <button class="qty-btn-card"
                                            (click)="updateQuantity(item, 1); $event.stopPropagation()"
                                            [disabled]="item.isAddingToCart || isDemoPreviewSupplier(section.id) || (item.maximumOrderQty && item.selectedQuantity >= item.maximumOrderQty)">+</button>
                                    </ng-container>
                                </div>
                                <ng-template #productAddBtn>
                                    <div class="add-btn-wrapper">
                                        <button class="add-btn"
                                            (click)="addToCart(item, section); $event.stopPropagation()"
                                            [disabled]="!item.is_in_stock || item.isAddingToCart || isDemoPreviewSupplier(section.id)"
                                            [title]="isDemoPreviewSupplier(section.id) ? demoDisabledActionTitle : 'Add to cart'">
                                            <div class="btn-loader"
                                                *ngIf="item.isAddingToCart">
                                                <div class="spinner-small"></div>
                                            </div>
                                            <ng-container *ngIf="!item.isAddingToCart">
                                                <!-- <span class="add-btn-text">ADD</span> -->
                                                <svg width="12"
                                                    height="12"
                                                    viewBox="0 0 18 18"
                                                    fill="none">
                                                    <path d="M9 4V14"
                                                        stroke="currentColor"
                                                        stroke-width="2.5"
                                                        stroke-linecap="round" />
                                                    <path d="M4 9H14"
                                                        stroke="currentColor"
                                                        stroke-width="2.5"
                                                        stroke-linecap="round" />
                                                </svg>
                                            </ng-container>
                                        </button>
                                        <span class="min-qty-label"
                                            *ngIf="item.minimumOrderQty && item.minimumOrderQty > 1">
                                            Min Qty {{ item.minimumOrderQty }}
                                        </span>
                                    </div>
                                </ng-template>
                            </div>

                        </div>
                    </div>

                    <!-- No Items Template -->
                    <ng-template #noItemsTemplate>
                        <div class="empty-supplier-state">
                            <img src="assets/images/placeholder-product.svg"
                                alt="No Items"
                                class="empty-icon" />
                            <p>No matches found for "{{ activeSearchItem }}" from this supplier.</p>
                        </div>
                    </ng-template>
                    <!-- Loading indicator for section -->
                    <div class="section-loading"
                        *ngIf="isLoading && section.items.length === 0">
                        <div class="spinner small"></div>
                        <span>Fetching results from {{ section.name }}...</span>
                    </div>
                </div>
            </ng-container>

            <!-- Empty State -->
            <div class="empty-state"
                *ngIf="!isInitializing && !isLoading && !isLoadingAllFav && hasGlobalNoResults()">
                <svg width="64"
                    height="64"
                    viewBox="0 0 64 64"
                    fill="none">
                    <circle cx="32"
                        cy="32"
                        r="30"
                        stroke="#ddd"
                        stroke-width="2" />
                    <path d="M24 28L32 36L40 28"
                        stroke="#ddd"
                        stroke-width="2"
                        stroke-linecap="round" />
                </svg>
                <h3>No results found</h3>
                <p>Try a different search term or check your supplier integrations.</p>
                <button class="back-btn"
                    (click)="goBack()">← Back to Purchase Manager</button>
            </div>
        </main>

        <!-- Supplier Item Drawer -->
        <div class="drawer-overlay"
            *ngIf="isDrawerOpen"
            (click)="closeDrawer()"></div>

        <div class="sidebar-drawer"
            [class.open]="isDrawerOpen">
            <!-- Close Button -->
            <button class="close-drawer"
                (click)="closeDrawer()">
                <i class="material-icons">close</i>
            </button>

            <!-- Drawer Content -->
            <div class="drawer-content"
                *ngIf="selectedSection">
                <!-- Supplier Header -->
                <div class="drawer-header">
                    <div class="supplier-brand">
                        <!-- Reuse Logos logic -->
                        <ng-container [ngSwitch]="selectedSection.id">
                            <img *ngSwitchCase="'hyperpure'"
                                src="assets/images/hyperpure-logo.png"
                                alt="Hyperpure"
                                class="drawer-logo" />
                            <img *ngSwitchCase="'dmart'"
                                src="assets/images/d-mart-logo.png"
                                alt="DMart"
                                class="drawer-logo" />
                            <img *ngSwitchCase="'udaan'"
                                src="assets/images/udaan-logo.png"
                                alt="Udaan"
                                class="drawer-logo" />
                            <img *ngSwitchCase="'deliverit'"
                                src="assets/images/deliverIt.png"
                                alt="DeliverIt"
                                class="drawer-logo" />
                            <div *ngSwitchCase="'local'"
                                class="local-drawer-brand">
                                <img src="assets/images/local-suppliers-logo.png"
                                    alt="Local Suppliers"
                                    class="drawer-logo" />
                            </div>
                        </ng-container>
                    </div>
                </div>

                <!-- Search & Filter -->
                <div class="drawer-actions">
                    <div class="drawer-search">
                        <i class="material-icons">search</i>
                        <input type="text"
                            [placeholder]="'Search within ' + selectedSection.name + '...'"
                            [(ngModel)]="drawerSearchText" />
                    </div>
                    <div class="drawer-sort">
                        <select [(ngModel)]="drawerSortOption">
                            <option value="relevance">Sort: Relevance</option>
                            <option value="price-low">Price: Low to High</option>
                            <option value="price-high">Price: High to Low</option>
                        </select>
                    </div>
                </div>

                <!-- Product List -->
                <div class="drawer-list-container">
                    <div class="drawer-list">
                        <div class="drawer-product-card"
                            *ngFor="let item of drawerFilteredItems">

                            <div class="product-thumb">
                                <img [src]="item.image_url || 'assets/images/placeholder-product.svg'"
                                    [alt]="item.item_name"
                                    onerror="this.src='assets/images/placeholder-product.svg'" />
                                <div class="badge-tag best-price-tag"
                                    *ngIf="item.mrp && item.rate < item.mrp">BEST PRICE</div>
                                <!-- Drawer Favourite Icon -->
                                <button class="fav-icon drawer-fav-icon"
                                    *ngIf="selectedSection"
                                    [class.filled]="isSupplierProductFav(selectedSection.id, item)"
                                    [disabled]="isDemoPreviewSupplier(selectedSection.id)"
                                    (click)="toggleProductFavourite(item, selectedSection, $event)"
                                    [title]="isDemoPreviewSupplier(selectedSection.id) ? demoDisabledActionTitle : (isSupplierProductFav(selectedSection.id, item) ? 'Remove from favourites' : 'Add to favourites')">
                                    <svg width="16"
                                        height="16"
                                        viewBox="0 0 18 18"
                                        fill="none">
                                        <path
                                            d="M9 15.75L7.9125 14.7638C3.9 11.1113 1.125 8.58375 1.125 5.5125C1.125 2.985 3.0975 1.125 5.625 1.125C7.0425 1.125 8.4075 1.78875 9 2.82375C9.5925 1.78875 10.9575 1.125 12.375 1.125C14.9025 1.125 16.875 2.985 16.875 5.5125C16.875 8.58375 14.1 11.1113 10.0875 14.7638L9 15.75Z"
                                            [attr.stroke]="isSupplierProductFav(selectedSection.id, item) ? '#E91E63' : '#4CAF50'"
                                            stroke-width="1.2"
                                            [attr.fill]="isSupplierProductFav(selectedSection.id, item) ? '#E91E63' : 'none'" />
                                    </svg>
                                </button>
                            </div>

                            <div class="product-details">
                                <div class="details-header">
                                    <h4 class="product-title">{{ item.item_name }}</h4>
                                    <div class="status-badge best-match-badge"
                                        *ngIf="item.isBestMatch">★ BEST MATCH</div>
                                    <div class="status-badge best-price-badge"
                                        *ngIf="!item.isBestMatch && item.mrp && item.rate < item.mrp">★ BEST PRICE</div>
                                </div>
                                <p class="product-meta">{{ item.quantity }} &nbsp; Pack of &nbsp; {{ item.unit }}</p>
                                <p class="product-supplier-name"
                                    *ngIf="item.platform === 'local'">{{ resolveSupplierName(item.supplierName || item.supplierId) }}</p>

                                <!-- Error Message Display -->
                                <div *ngIf="item.cartError"
                                    class="drawer-cart-error">
                                    <i class="material-icons">error_outline</i>
                                    {{ item.cartError }}
                                </div>

                                <div class="product-footer">
                                    <div class="price-box">
                                        <div class="main-prices">
                                            <span class="drawer-price">₹{{ item.rate.toFixed(2) }}</span>
                                            <span class="drawer-mrp"
                                                *ngIf="item.mrp && item.mrp > item.rate">₹{{ item.mrp.toFixed(2)
                                                }}</span>
                                        </div>
                                        <div class="unit-rate">₹{{ (item.rate / item.quantity).toFixed(2) }}/{{
                                            item.unit }}
                                        </div>
                                        <!-- Bulk Price Tiers in Drawer -->
                                        <div class="bulk-price-tiers-drawer"
                                            *ngIf="item.bulkPrices && item.bulkPrices.length > 0">
                                            <div class="bulk-box-header">
                                                <svg width="10"
                                                    height="10"
                                                    viewBox="0 0 16 16"
                                                    fill="none">
                                                    <path d="M14 2H2v12h12V2zM7 11H5V7h2v4zm4 0H9V5h2v6z"
                                                        fill="#059669" />
                                                </svg>
                                                Bulk Offers
                                            </div>
                                            <div class="bulk-tier-drawer"
                                                *ngFor="let bp of item.bulkPrices"
                                                [class.active-tier]="isActiveBulkTier(item, bp)">
                                                <span class="bulk-qty">Buy {{ bp.qty }}+</span>
                                                <span class="bulk-rate">₹{{ bp.price }}/{{ item.unit }}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Quantity Controls -->
                                    <div class="qty-wrapper">
                                        <div class="qty-control"
                                            *ngIf="item.selectedQuantity && item.selectedQuantity > 0; else addButton">
                                            <button class="qty-btn"
                                                (click)="updateQuantity(item, -1)"
                                                [disabled]="isDemoPreviewSupplier(selectedSection?.id)">-</button>
                                            <span class="qty-val">{{ item.selectedQuantity }}</span>
                                            <button class="qty-btn"
                                                (click)="updateQuantity(item, 1)"
                                                [disabled]="isDemoPreviewSupplier(selectedSection?.id) || (item.maximumOrderQty && item.selectedQuantity >= item.maximumOrderQty)">+</button>
                                        </div>
                                        <ng-template #addButton>
                                            <button class="qty-add-btn"
                                                (click)="openDrawer(selectedSection!, item)"
                                                [disabled]="isDemoPreviewSupplier(selectedSection?.id)"
                                                [title]="isDemoPreviewSupplier(selectedSection?.id) ? demoDisabledActionTitle : 'Add to cart'">
                                                <svg width="14"
                                                    height="14"
                                                    viewBox="0 0 14 14"
                                                    fill="none">
                                                    <path d="M7 2.33334V11.6667"
                                                        stroke="currentColor"
                                                        stroke-width="1.8"
                                                        stroke-linecap="round" />
                                                    <path d="M2.33331 7H11.6666"
                                                        stroke="currentColor"
                                                        stroke-width="1.8"
                                                        stroke-linecap="round" />
                                                </svg>
                                            </button>
                                            <span class="min-qty-label-drawer"
                                                *ngIf="item.minimumOrderQty && item.minimumOrderQty > 1">
                                                Min Qty {{ item.minimumOrderQty }}
                                            </span>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Bottom Cart Bar -->
        <div class="bottom-cart-bar"
            [class.demo-cart-bar]="isPublicDemo"
            *ngIf="hasCartItems && !hyperpureSupplier?.showIframe && !deliveritSupplier?.showIframe">
            <div class="cart-total-section">
                <button class="cart-icon-btn"
                    (click)="viewFullCart()">
                    <svg width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none">
                        <path
                            d="M7.4 17C6.84 17 6.4 17.44 6.4 18C6.4 18.56 6.84 19 7.4 19C7.96 19 8.4 18.56 8.4 18C8.4 17.44 7.96 17 7.4 17ZM17.4 17C16.84 17 16.4 17.44 16.4 18C16.4 18.56 16.84 19 17.4 19C17.96 19 18.4 18.56 18.4 18C18.4 17.44 17.96 17 17.4 17ZM15.9 14.5C16.65 14.5 17.29 14.07 17.6 13.43L20.8 7.64C20.89 7.47 20.9 7.28 20.9 7.1C20.9 6.55 20.45 6.1 19.9 6.1H6.62L5.68 4.1H2.4V6.1H4.4L8.01 13.68L6.72 16.03C6.49 16.44 6.4 16.92 6.4 17.43C6.4 18.3 7.12 19.03 8 19.03H19.4V17.03H8.42C8.28 17.03 8.16 16.91 8.16 16.77L8.2 16.62L9.31 14.6L15.9 14.5V14.5Z"
                            fill="#333" />
                    </svg>
                </button>
                <div class="cart-total-info">
                    <span class="cart-label">CART VALUE</span>
                    <span class="cart-value">₹{{ totalCartValue.toFixed(2) }}</span>
                </div>

                <button class="scroll-btn left"
                    (click)="scrollCarts('left')">
                    <i class="material-icons">chevron_left</i>
                </button>
            </div>

            <div class="supplier-carts-wrapper">
                <div class="supplier-carts-container"
                    #cartsContainer>
                    <div class="supplier-cart-card"
                        [class.cart-add-effect]="cartHighlightAction === 'add' && (highlightedCartPlatform === cart.platform || (cart.platform === 'local' && highlightedCartPlatform === cart.supplierName))"
                        [class.cart-remove-effect]="cartHighlightAction === 'remove' && (highlightedCartPlatform === cart.platform || (cart.platform === 'local' && highlightedCartPlatform === cart.supplierName))"
                        *ngFor="let cart of cartSections">
                        <div class="cart-provider-logo">
                            <ng-container [ngSwitch]="cart.platform">
                                <span class="provider-icon ud-icon"
                                    *ngSwitchCase="'udaan'">
                                    <img src="assets/images/udaan_cart.png"
                                        alt="Udaan"
                                        onerror="this.style.display='none'">
                                </span>
                                <span class="provider-icon hp-icon"
                                    *ngSwitchCase="'hyperpure'">
                                    <img src="assets/images/hyperpure_cart.png"
                                        alt="Hyperpure"
                                        onerror="this.style.display='none'">
                                </span>
                                <span class="provider-icon dm-icon"
                                    *ngSwitchCase="'dmart'">
                                    <img src="assets/images/dmart_cart.png"
                                        alt="DMart"
                                        onerror="this.style.display='none'">
                                </span>
                                <span class="provider-icon local-icon"
                                    *ngSwitchCase="'local'">
                                    <img src="assets/images/local-suppliers-logo.png"
                                        alt="Local Suppliers"
                                        onerror="this.style.display='none'">
                                </span>
                                <span class="provider-icon deliverit-icon"
                                    *ngSwitchCase="'deliverit'">
                                    <img src="assets/images/deliverIt.png"
                                        alt="DeliverIt"
                                        onerror="this.style.display='none'">
                                </span>
                            </ng-container>
                        </div>
                        <div class="cart-provider-info">
                            <span class="provider-name"
                                [title]="resolveSupplierName(cart.supplierName)">{{
                                resolveSupplierName(cart.supplierName) |
                                uppercase }}</span>
                            <div class="provider-cart-meta">
                                <span class="provider-cart-value">₹{{ cart.totalValue.toFixed(2) }}</span>
                                <span class="provider-cart-items">{{ cart.totalCount }} {{ cart.totalCount === 1 ?
                                    'item' :
                                    'items' }}</span>
                            </div>
                        </div>
                        <button class="checkout-btn"
                            *ngIf="cart.platform !== 'local'"
                            (mouseup)="checkoutSupplier(cart)">CHECKOUT</button>
                        <button class="checkout-btn create-po"
                            *ngIf="cart.platform === 'local'"
                            (mouseup)="createPO(cart)">CREATE PO</button>
                    </div>
                </div>

                <button class="scroll-btn right"
                    (click)="scrollCarts('right')">
                    <i class="material-icons">chevron_right</i>
                </button>
            </div>
        </div>
    </div>

    <!-- Final Checkout Modal -->
    <div class="checkout-modal-overlay"
        *ngIf="isCheckoutDrawerOpen"
        (click)="closeCheckoutDrawer()">

        <div class="checkout-modal-container"
            (click)="$event.stopPropagation()">

            <ng-container *ngIf="selectedCheckoutCart">
                <!-- Header -->
                <div class="modal-header">
                    <div class="brand-info">
                        <ng-container [ngSwitch]="selectedCheckoutCart.platform">
                            <img *ngSwitchCase="'udaan'"
                                src="assets/images/udaan-logo.png"
                                alt="Udaan"
                                class="brand-image">
                            <img *ngSwitchCase="'deliverit'"
                                src="assets/images/deliverIt.png"
                                alt="DeliverIt"
                                class="brand-image">
                            <img *ngSwitchCase="'hyperpure'"
                                src="assets/images/hyperpure-logo.png"
                                alt="Hyperpure"
                                class="brand-image">
                            <img *ngSwitchCase="'dmart'"
                                src="assets/images/d-mart-logo.png"
                                alt="DMart"
                                class="brand-image">
                            <div *ngSwitchCase="'local'"
                                class="brand-local">
                                <img src="assets/images/local-suppliers-logo.png"
                                    alt="Local Suppliers"
                                    class="brand-image">
                            </div>
                        </ng-container>
                        <!-- <span class="checkout-supplier-name"
                        *ngIf="selectedCheckoutCart.supplierName">
                        {{ resolveSupplierName(selectedCheckoutCart.supplierName) }}
                    </span> -->
                    </div>
                    <button class="close-btn"
                        (click)="closeCheckoutDrawer()">
                        <i class="material-icons">close</i>
                    </button>
                </div>

                <!-- Summary Card -->
                <div class="modal-summary-card">
                    <!-- Udaan Promo Banner -->
                    <div class="checkout-udaan-promo"
                        *ngIf="selectedCheckoutCart.platform === 'udaan'">
                        <img src="assets/images/udaan-promo-text.png"
                            alt="Flat ₹500 off on first 5 Orders!" />
                    </div>
                    <div class="summary-row">
                        <div class="summary-left">
                            <div class="cart-icon-wrapper">
                                <svg width="20"
                                    height="20"
                                    viewBox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM1 2V4H3L6.6 11.59L5.24 14.04C5.09 14.32 5 14.65 5 15C5 16.1 5.9 17 7 17H19V15H7.42C7.28 15 7.17 14.89 7.17 14.75L7.2 14.63L8.1 13H15.55C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C20.96 5.34 21 5.17 21 5C21 4.45 20.55 4 20 4H5.21L4.27 2H1ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
                                        fill="#E84F5A" />
                                </svg>
                            </div>
                            <div class="summary-details">
                                <span class="lbl-items">Items</span>
                                <span class="val-items">{{ selectedCheckoutCart.totalCount }} Items</span>
                            </div>
                        </div>
                        <div class="summary-right">
                            <span class="lbl-amount">Total Amount</span>
                            <span class="val-amount">₹{{ selectedCheckoutCart.totalValue.toFixed(0) }}</span>
                        </div>
                    </div>
                </div>

                <!-- Items Table -->
                <div class="modal-table-container">

                    <!-- Hyperpure/DMart: Collapsible bifurcated view -->
                    <ng-container
                        *ngIf="selectedCheckoutCart.platform === 'hyperpure' || selectedCheckoutCart.platform === 'dmart' || selectedCheckoutCart.platform === 'deliverit'; else defaultTable">

                        <!-- Section 0: Market Best Items -->
                        <div class="collapsible-section"
                            *ngIf="marketBestItems.length > 0">
                            <div class="collapsible-header"
                                (click)="isMarketBestItemsCollapsed = !isMarketBestItemsCollapsed">
                                <div class="collapsible-title">
                                    <span class="collapsible-dot market-best-dot"></span>
                                    <span>Market Best Items</span>
                                    <span class="collapsible-count">({{ marketBestItems.length }})</span>
                                </div>
                                <div class="market-best-header-actions">
                                    <button class="remove-all-market-best-btn"
                                        (click)="removeAllMarketBestItems(selectedCheckoutCart.platform); $event.stopPropagation()"
                                        title="Remove Market Best items from this cart">Undo</button>
                                    <i class="material-icons collapsible-chevron"
                                        [class.rotated]="isMarketBestItemsCollapsed">expand_more</i>
                                </div>
                            </div>
                            <div class="collapsible-body"
                                [class.collapsed]="isMarketBestItemsCollapsed">
                                <table class="checkout-table">
                                    <thead>
                                        <tr>
                                            <th class="col-item">Item</th>
                                            <th class="col-qty">Qty.</th>
                                            <th class="col-unit">Unit</th>
                                            <th class="col-rate">Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let item of marketBestItems">
                                            <tr>
                                                <td class="col-item">{{ item.item_name }}</td>
                                                <td class="col-qty">
                                                    <div class="qty-controls">
                                                        <div class="qty-loader-inline"
                                                            *ngIf="item.isAddingToCart">
                                                            <div class="spinner-small"></div>
                                                        </div>
                                                        <ng-container *ngIf="!item.isAddingToCart">
                                                            <button class="qty-btn minus"
                                                                (mouseup)="updateCheckoutQty(item, -1)"
                                                                [disabled]="item.isAddingToCart">&#8722;</button>
                                                            <input type="number"
                                                                class="qty-input"
                                                                [value]="item.selectedQuantity"
                                                                min="1"
                                                                [attr.max]="item.maximumOrderQty || null"
                                                                [disabled]="item.isAddingToCart"
                                                                (change)="onCheckoutQtyChange(item, $event)">
                                                            <button class="qty-btn plus"
                                                                (mouseup)="updateCheckoutQty(item, 1)"
                                                                [disabled]="item.isAddingToCart || (item.maximumOrderQty && item.selectedQuantity >= item.maximumOrderQty)">+</button>
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td class="col-unit">{{ item.unit }}</td>
                                                <td class="col-rate fw-bold"
                                                    *ngIf="item.rate && item.rate > 0">
                                                    <div class="rate-tooltip-wrapper">
                                                        <div class="checkout-rate-info">
                                                            <span>&#8377;{{ (getCartDisplayRate(item) *
                                                                item.selectedQuantity).toFixed(2)
                                                                }}</span>
                                                            <span class="checkout-bulk-badge"
                                                                *ngIf="item.baseRate && item.rate < item.baseRate">Bulk</span>
                                                        </div>
                                                        <div class="checkout-per-unit"
                                                            *ngIf="item.baseRate && item.rate < item.baseRate">&#8377;{{
                                                            getCartDisplayRate(item).toFixed(2) }}/{{ item.unit }}</div>
                                                        <span class="rate-tooltip"
                                                            *ngIf="getCartPricePerUnit(item)">{{
                                                            getCartPricePerUnit(item)
                                                            }}</span>
                                                    </div>
                                                </td>
                                                <td class="col-rate"
                                                    *ngIf="!item.rate || item.rate <= 0">
                                                    <span class="price-not-available">Price not available</span>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Section 1: Items Added or Modified (excluding Market Best) -->
                        <div class="collapsible-section"
                            *ngIf="sessionModifiedItemsExcludingMarketBest.length > 0">
                            <div class="collapsible-header"
                                (click)="selectedCheckoutCart.platform === 'dmart' ? isDmartSessionItemsCollapsed = !isDmartSessionItemsCollapsed : (selectedCheckoutCart.platform === 'deliverit' ? isDeliveritSessionItemsCollapsed = !isDeliveritSessionItemsCollapsed : isSessionItemsCollapsed = !isSessionItemsCollapsed)">
                                <div class="collapsible-title">
                                    <span class="collapsible-dot session-dot"></span>
                                    <span>Items Added or Modified</span>
                                    <span class="collapsible-count">({{ sessionModifiedItemsExcludingMarketBest.length
                                        }})</span>
                                </div>
                                <i class="material-icons collapsible-chevron"
                                    [class.rotated]="selectedCheckoutCart.platform === 'dmart' ? isDmartSessionItemsCollapsed : (selectedCheckoutCart.platform === 'deliverit' ? isDeliveritSessionItemsCollapsed : isSessionItemsCollapsed)">expand_more</i>
                            </div>
                            <div class="collapsible-body"
                                [class.collapsed]="selectedCheckoutCart.platform === 'dmart' ? isDmartSessionItemsCollapsed : (selectedCheckoutCart.platform === 'deliverit' ? isDeliveritSessionItemsCollapsed : isSessionItemsCollapsed)">
                                <table class="checkout-table">
                                    <thead>
                                        <tr>
                                            <th class="col-item">Item</th>
                                            <th class="col-qty">Qty.</th>
                                            <th class="col-unit">Unit</th>
                                            <th class="col-rate">Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let item of sessionModifiedItems">
                                            <tr>
                                                <td class="col-item">{{ item.item_name }}</td>
                                                <td class="col-qty">
                                                    <div class="qty-controls">
                                                        <div class="qty-loader-inline"
                                                            *ngIf="item.isAddingToCart">
                                                            <div class="spinner-small"></div>
                                                        </div>
                                                        <ng-container *ngIf="!item.isAddingToCart">
                                                            <button class="qty-btn minus"
                                                                (mouseup)="updateCheckoutQty(item, -1)"
                                                                [disabled]="item.isAddingToCart">−</button>
                                                            <input type="number"
                                                                class="qty-input"
                                                                [value]="item.selectedQuantity"
                                                                min="1"
                                                                [attr.max]="item.maximumOrderQty || null"
                                                                [disabled]="item.isAddingToCart"
                                                                (change)="onCheckoutQtyChange(item, $event)">
                                                            <button class="qty-btn plus"
                                                                (mouseup)="updateCheckoutQty(item, 1)"
                                                                [disabled]="item.isAddingToCart || (item.maximumOrderQty && item.selectedQuantity >= item.maximumOrderQty)">+</button>
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td class="col-unit">{{ item.unit }}</td>
                                                <td class="col-rate fw-bold"
                                                    *ngIf="item.rate && item.rate > 0">
                                                    <div class="rate-tooltip-wrapper">
                                                        <div class="checkout-rate-info">
                                                            <span>₹{{ (getCartDisplayRate(item) *
                                                                item.selectedQuantity).toFixed(2)
                                                                }}</span>
                                                            <span class="checkout-bulk-badge"
                                                                *ngIf="item.baseRate && item.rate < item.baseRate">Bulk</span>
                                                        </div>
                                                        <div class="checkout-per-unit"
                                                            *ngIf="item.baseRate && item.rate < item.baseRate">₹{{
                                                            getCartDisplayRate(item).toFixed(2)
                                                            }}/{{ item.unit }}</div>
                                                        <span class="rate-tooltip"
                                                            *ngIf="getCartPricePerUnit(item)">{{
                                                            getCartPricePerUnit(item)
                                                            }}</span>
                                                    </div>
                                                </td>
                                                <td class="col-rate"
                                                    *ngIf="!item.rate || item.rate <= 0">
                                                    <span class="price-not-available">Price not available</span>
                                                </td>
                                            </tr>
                                            <tr *ngIf="item.cartError"
                                                class="error-row">
                                                <td colspan="4"
                                                    class="error-cell">
                                                    <div class="cart-error-message">
                                                        <svg width="16"
                                                            height="16"
                                                            viewBox="0 0 16 16"
                                                            fill="none">
                                                            <path
                                                                d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C11.59 14.5 14.5 11.59 14.5 8C14.5 4.41 11.59 1.5 8 1.5ZM8.75 11.25H7.25V9.75H8.75V11.25ZM8.75 8.25H7.25V4.75H8.75V8.25Z"
                                                                fill="#dc3545" />
                                                        </svg>
                                                        <span>{{ item.cartError }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- Section 2: Items from Supplier Cart -->
                        <div class="collapsible-section">
                            <div class="collapsible-header"
                                (click)="selectedCheckoutCart.platform === 'dmart' ? isDmartCartItemsCollapsed = !isDmartCartItemsCollapsed : (selectedCheckoutCart.platform === 'deliverit' ? isDeliveritCartItemsCollapsed = !isDeliveritCartItemsCollapsed : isCartItemsCollapsed = !isCartItemsCollapsed)">
                                <div class="collapsible-title">
                                    <span class="collapsible-dot cart-dot"></span>
                                    <span>Items from {{ selectedCheckoutCart.platform === 'dmart' ? 'DMart' :
                                        (selectedCheckoutCart.platform === 'udaan' ? 'Udaan' : (selectedCheckoutCart.platform === 'deliverit' ? 'DeliverIt' : 'Hyperpure')) }}
                                        Cart</span>
                                    <span class="collapsible-count">({{ nonSessionCartItems.length }})</span>
                                </div>
                                <i class="material-icons collapsible-chevron"
                                    [class.rotated]="selectedCheckoutCart.platform === 'dmart' ? isDmartCartItemsCollapsed : (selectedCheckoutCart.platform === 'deliverit' ? isDeliveritCartItemsCollapsed : isCartItemsCollapsed)">expand_more</i>
                            </div>
                            <div class="collapsible-body"
                                [class.collapsed]="selectedCheckoutCart.platform === 'dmart' ? isDmartCartItemsCollapsed : (selectedCheckoutCart.platform === 'deliverit' ? isDeliveritCartItemsCollapsed : isCartItemsCollapsed)">
                                <table class="checkout-table">
                                    <thead>
                                        <tr>
                                            <th class="col-item">Item</th>
                                            <th class="col-qty">Qty.</th>
                                            <th class="col-unit">Unit</th>
                                            <th class="col-rate">Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let item of nonSessionCartItems">
                                            <tr>
                                                <td class="col-item">{{ item.item_name }}</td>
                                                <td class="col-qty">
                                                    <div class="qty-controls">
                                                        <div class="qty-loader-inline"
                                                            *ngIf="item.isAddingToCart">
                                                            <div class="spinner-small"></div>
                                                        </div>
                                                        <ng-container *ngIf="!item.isAddingToCart">
                                                            <button class="qty-btn minus"
                                                                (mouseup)="updateCheckoutQty(item, -1)"
                                                                [disabled]="item.isAddingToCart">−</button>
                                                            <input type="number"
                                                                class="qty-input"
                                                                [value]="item.selectedQuantity"
                                                                min="1"
                                                                [attr.max]="item.maximumOrderQty || null"
                                                                [disabled]="item.isAddingToCart"
                                                                (change)="onCheckoutQtyChange(item, $event)">
                                                            <button class="qty-btn plus"
                                                                (mouseup)="updateCheckoutQty(item, 1)"
                                                                [disabled]="item.isAddingToCart || (item.maximumOrderQty && item.selectedQuantity >= item.maximumOrderQty)">+</button>
                                                        </ng-container>
                                                    </div>
                                                </td>
                                                <td class="col-unit">{{ item.unit }}</td>
                                                <td class="col-rate fw-bold"
                                                    *ngIf="item.rate && item.rate > 0">
                                                    <div class="rate-tooltip-wrapper">
                                                        <div class="checkout-rate-info">
                                                            <span>₹{{ (getCartDisplayRate(item) *
                                                                item.selectedQuantity).toFixed(2)
                                                                }}</span>
                                                            <span class="checkout-bulk-badge"
                                                                *ngIf="item.baseRate && item.rate < item.baseRate">Bulk</span>
                                                        </div>
                                                        <div class="checkout-per-unit"
                                                            *ngIf="item.baseRate && item.rate < item.baseRate">₹{{
                                                            getCartDisplayRate(item).toFixed(2)
                                                            }}/{{ item.unit }}</div>
                                                        <span class="rate-tooltip"
                                                            *ngIf="getCartPricePerUnit(item)">{{
                                                            getCartPricePerUnit(item)
                                                            }}</span>
                                                    </div>
                                                </td>
                                                <td class="col-rate"
                                                    *ngIf="!item.rate || item.rate <= 0">
                                                    <span class="price-not-available">Price not available</span>
                                                </td>
                                            </tr>
                                            <tr *ngIf="item.cartError"
                                                class="error-row">
                                                <td colspan="4"
                                                    class="error-cell">
                                                    <div class="cart-error-message">
                                                        <svg width="16"
                                                            height="16"
                                                            viewBox="0 0 16 16"
                                                            fill="none">
                                                            <path
                                                                d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C11.59 14.5 14.5 11.59 14.5 8C14.5 4.41 11.59 1.5 8 1.5ZM8.75 11.25H7.25V9.75H8.75V11.25ZM8.75 8.25H7.25V4.75H8.75V8.25Z"
                                                                fill="#dc3545" />
                                                        </svg>
                                                        <span>{{ item.cartError }}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <!-- DeliverIt Extra Charges -->
                        <div class="deliverit-charges-summary"
                            *ngIf="selectedCheckoutCart.platform === 'deliverit' && deliveritSupplier && (deliveritSupplier.deliveryCharge > 0 || deliveritSupplier.smallCartCharge > 0 || deliveritSupplier.smallCartWaiveOffText)">
                            
                            <div class="charge-row" *ngIf="deliveritSupplier.deliveryCharge > 0">
                                <span class="charge-label">Delivery Charge</span>
                                <span class="charge-value">₹{{ deliveritSupplier.deliveryCharge }}</span>
                            </div>

                            <div class="charge-row" *ngIf="deliveritSupplier.smallCartCharge > 0">
                                <span class="charge-label">Small Cart Charge</span>
                                <span class="charge-value">₹{{ deliveritSupplier.smallCartCharge }}</span>
                            </div>

                            <div class="waive-off-text" *ngIf="deliveritSupplier.smallCartWaiveOffText">
                                <i class="material-icons info-icon">info_outline</i>
                                <span>{{ deliveritSupplier.smallCartWaiveOffText }}</span>
                            </div>
                        </div>

                    </ng-container>

                    <!-- Default: Single table for non-HP or when no session items -->
                    <ng-template #defaultTable>
                        <!-- Market Best Items Section (for Udaan/Local) -->
                        <div class="collapsible-section"
                            *ngIf="marketBestItems.length > 0">
                            <div class="collapsible-header"
                                (click)="isMarketBestItemsCollapsed = !isMarketBestItemsCollapsed">
                                <div class="collapsible-title">
                                    <span class="collapsible-dot market-best-dot"></span>
                                    <span>Market Best Items</span>
                                    <span class="collapsible-count">({{ marketBestItems.length }})</span>
                                </div>
                                <div class="market-best-header-actions">
                                    <button class="remove-all-market-best-btn"
                                        (click)="removeAllMarketBestItems(selectedCheckoutCart.platform); $event.stopPropagation()">Undo</button>
                                    <i class="material-icons collapsible-chevron"
                                        [class.rotated]="isMarketBestItemsCollapsed">expand_more</i>
                                </div>
                            </div>
                            <div class="collapsible-body"
                                [class.collapsed]="isMarketBestItemsCollapsed">
                                <table class="checkout-table">
                                    <thead>
                                        <tr>
                                            <th class="col-item">Item</th>
                                            <th class="col-qty">Qty.</th>
                                            <th class="col-unit">Unit</th>
                                            <th class="col-rate">Rate</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngFor="let item of marketBestItems">
                                            <tr>
                                                <td class="col-item">{{ item.item_name }}</td>
                                                <td class="col-qty">{{ item.selectedQuantity }}</td>
                                                <td class="col-unit">{{ item.unit }}</td>
                                                <td class="col-rate fw-bold"
                                                    *ngIf="item.rate && item.rate > 0">
                                                    <div class="rate-tooltip-wrapper">
                                                        &#8377;{{ (item.rate * item.selectedQuantity).toFixed(2) }}
                                                        <span class="rate-tooltip"
                                                            *ngIf="item.cart_price_per_unit">{{ item.cart_price_per_unit
                                                            }}</span>
                                                    </div>
                                                </td>
                                                <td class="col-rate"
                                                    *ngIf="!item.rate || item.rate <= 0">
                                                    <span class="price-not-available">Price not available</span>
                                                </td>
                                            </tr>
                                        </ng-container>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <table class="checkout-table">
                            <thead>
                                <tr>
                                    <th class="col-item">Item</th>
                                    <th class="col-qty">Qty.</th>
                                    <th class="col-unit">Unit</th>
                                    <th class="col-rate">Rate</th>
                                </tr>
                            </thead>
                            <tbody>
                                <ng-container *ngFor="let item of nonMarketBestCartItems">
                                    <tr>
                                        <td class="col-item">{{ item.item_name }}</td>
                                        <td class="col-qty">
                                            <div class="qty-controls">
                                                <div class="qty-loader-inline"
                                                    *ngIf="item.isAddingToCart">
                                                    <div class="spinner-small"></div>
                                                </div>
                                                <ng-container *ngIf="!item.isAddingToCart">
                                                    <button class="qty-btn minus"
                                                        (mouseup)="updateCheckoutQty(item, -1)"
                                                        [disabled]="item.isAddingToCart">−</button>
                                                    <input type="number"
                                                        class="qty-input"
                                                        [value]="item.selectedQuantity"
                                                        min="1"
                                                        [attr.max]="item.maximumOrderQty || null"
                                                        [disabled]="item.isAddingToCart"
                                                        (change)="onCheckoutQtyChange(item, $event)">
                                                    <button class="qty-btn plus"
                                                        (mouseup)="updateCheckoutQty(item, 1)"
                                                        [disabled]="item.isAddingToCart || (item.maximumOrderQty && item.selectedQuantity >= item.maximumOrderQty)">+</button>
                                                </ng-container>
                                            </div>
                                        </td>
                                        <td class="col-unit">{{ item.unit }}</td>
                                        <td class="col-rate fw-bold"
                                            *ngIf="item.rate && item.rate > 0">
                                            <div class="rate-tooltip-wrapper">
                                                <div class="checkout-rate-info">
                                                    <span>₹{{ (item.rate * item.selectedQuantity).toFixed(2) }}</span>
                                                    <span class="checkout-bulk-badge"
                                                        *ngIf="item.baseRate && item.rate < item.baseRate">Bulk</span>
                                                </div>
                                                <div class="checkout-per-unit"
                                                    *ngIf="item.baseRate && item.rate < item.baseRate">₹{{
                                                    item.rate.toFixed(2) }}/{{
                                                    item.unit }}</div>
                                                <span class="rate-tooltip"
                                                    *ngIf="item.cart_price_per_unit">{{ item.cart_price_per_unit
                                                    }}</span>
                                            </div>
                                        </td>
                                        <td class="col-rate"
                                            *ngIf="!item.rate || item.rate <= 0">
                                            <span class="price-not-available">Price not available</span>
                                        </td>
                                    </tr>
                                    <tr *ngIf="item.cartError"
                                        class="error-row">
                                        <td colspan="4"
                                            class="error-cell">
                                            <div class="cart-error-message">
                                                <svg width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none">
                                                    <path
                                                        d="M8 1.5C4.41 1.5 1.5 4.41 1.5 8C1.5 11.59 4.41 14.5 8 14.5C11.59 14.5 14.5 11.59 14.5 8C14.5 4.41 11.59 1.5 8 1.5ZM8.75 11.25H7.25V9.75H8.75V11.25ZM8.75 8.25H7.25V4.75H8.75V8.25Z"
                                                        fill="#dc3545" />
                                                </svg>
                                                <span>{{ item.cartError }}</span>
                                            </div>
                                        </td>
                                    </tr>
                                </ng-container>
                            </tbody>
                        </table>
                    </ng-template>
                </div>

                <!-- Footer -->
                <div class="modal-footer">
                    <button class="proceed-to-buy-btn"
                        (click)="proceedToBuy()">Proceed to Buy</button>
                </div>
            </ng-container>

        </div>
    </div>

    <!-- Hyperpure Supplier Child Component (handles iframe overlay) -->
    <app-hyperpure-supplier #hyperpureSupplier
        (cartUpdated)="onChildCartUpdate($event)"
        (iframeClosed)="onIframeClosed()">
    </app-hyperpure-supplier>

    <!-- DMart Supplier Child Component (headless, no template) -->
    <app-dmart-supplier #dmartSupplier
        (cartUpdated)="onChildCartUpdate($event)">
    </app-dmart-supplier>

    <!-- Udaan Supplier Child Component (headless, no template) -->
    <app-udaan-supplier #udaanSupplier
        [entityId]="selectedEntityId"
        [storeUuid]="udaanStoreUuid"
        [apiStoreId]="udaanApiStoreId"
        (cartUpdated)="onChildCartUpdate($event)">
    </app-udaan-supplier>

    <!-- DeliverIt Supplier Child Component (handles iframe overlay) -->
    <app-deliverit-supplier #deliveritSupplier
        [entityId]="selectedEntityId"
        [storeData]="deliveritStoreData"
        (cartUpdated)="onChildCartUpdate($event)"
        (iframeClosed)="onIframeClosed()">
    </app-deliverit-supplier>

    <!-- Local Supplier PO Modal -->
    <app-local-supplier-purchase-order-modal #localSupplierPOModal
        (poGenerated)="onPOGenerated($event)">
    </app-local-supplier-purchase-order-modal>

    <!-- Best Match Popup Modal -->
    <div class="best-match-modal-overlay"
        *ngIf="isBestMatchPopupOpen"
        (click)="closeBestMatchPopup()">

        <div class="best-match-modal"
            (click)="$event.stopPropagation()">

            <!-- Header -->
            <div class="bm-modal-header">
                <div class="bm-header-info">
                    <div class="bm-header-icon">
                        <i class="material-icons"
                            style="color: #7c3aed; font-size: 20px;">auto_awesome</i>
                    </div>
                    <div>
                        <h3>Auto Fill Cart</h3>
                        <p>Lowest price item per search from your auto-fill suppliers</p>
                    </div>
                </div>
                <button class="bm-close-btn"
                    (click)="closeBestMatchPopup()">
                    <i class="material-icons">close</i>
                </button>
            </div>

            <!-- Select All -->
            <div class="bm-select-all">
                <label class="bm-checkbox-label">
                    <input type="checkbox"
                        [checked]="selectAllBestMatches"
                        (change)="toggleSelectAllBestMatches()"
                        [disabled]="bestMatchCandidates.length === alreadyAddedBestMatchCount">
                    <span class="bm-checkbox-custom"></span>
                    <span>Select All &nbsp;<span class="bm-select-count">{{ bestMatchCandidates.length }} items</span>
                        <span class="bm-added-summary"
                            *ngIf="alreadyAddedBestMatchCount > 0">
                            ({{ alreadyAddedBestMatchCount }} already added)
                        </span>
                    </span>
                </label>
            </div>

            <!-- Items List -->
            <div class="bm-items-list">
                <div class="bm-item-card"
                    *ngFor="let candidate of bestMatchCandidates"
                    [class.bm-item-selected]="candidate.isSelected && !candidate.isAlreadyAdded"
                    [class.bm-item-added]="candidate.isAlreadyAdded">

                    <label class="bm-item-checkbox"
                        [class.bm-checkbox-disabled]="candidate.isAlreadyAdded || isDemoPreviewSupplier(candidate.platform)">
                        <input type="checkbox"
                            [(ngModel)]="candidate.isSelected"
                            (change)="onBestMatchSelectionChange()"
                            [disabled]="candidate.isAlreadyAdded || isDemoPreviewSupplier(candidate.platform)">
                        <span class="bm-checkbox-custom"
                            *ngIf="!candidate.isAlreadyAdded"></span>
                        <span class="bm-added-check"
                            *ngIf="candidate.isAlreadyAdded">
                            <svg width="17"
                                height="17"
                                viewBox="0 0 17 17"
                                fill="none">
                                <rect width="17"
                                    height="17"
                                    rx="4"
                                    fill="#16a34a" />
                                <path d="M4.5 8.5L7 11L12.5 5.5"
                                    stroke="#fff"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </span>
                    </label>

                    <div class="bm-item-image">
                        <img [src]="candidate.item.image_url || candidate.item.product_images || 'assets/images/placeholder-product.svg'"
                            onerror="this.src='assets/images/placeholder-product.svg'" />
                    </div>

                    <div class="bm-item-details">
                        <div class="bm-item-for-tag">for: <strong>{{ candidate.searchItemName | titlecase }}</strong>
                        </div>
                        <h4 class="bm-item-name">{{ candidate.item.item_name }}</h4>
                        <div class="bm-item-meta">
                            <img *ngIf="getPlatformLogo(candidate.platform)"
                                [src]="getPlatformLogo(candidate.platform)"
                                class="bm-platform-logo" />
                            <span class="bm-platform-name"
                                *ngIf="!getPlatformLogo(candidate.platform)">{{ candidate.platformLabel }}</span>
                            <span class="bm-dot-sep">&#183;</span>
                            <span class="bm-item-unit">{{ candidate.item.unit }}</span>
                            <span class="demo-preview-chip"
                                *ngIf="isDemoPreviewSupplier(candidate.platform)">Preview</span>
                        </div>
                        <div class="bm-item-added-badge"
                            *ngIf="candidate.isAlreadyAdded">
                            <svg width="10"
                                height="10"
                                viewBox="0 0 10 10"
                                fill="none">
                                <path d="M2 5L4 7L8 3"
                                    stroke="#16a34a"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            Already in cart
                        </div>
                        <div class="bm-item-in-cart-badge"
                            *ngIf="candidate.isAlreadyInCart && !candidate.isAlreadyAdded">
                            <svg width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none">
                                <path
                                    d="M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1z"
                                    fill="#f59e0b" />
                            </svg>
                            {{ candidate.existingCartQty }} already in cart
                        </div>
                        <div class="bm-item-min-qty"
                            *ngIf="candidate.minimumOrderQty > 1 && !candidate.isAlreadyAdded && !candidate.isAlreadyInCart">
                            Min: {{ candidate.minimumOrderQty }}
                        </div>
                    </div>

                    <div class="bm-item-pricing">
                        <div class="bm-price-line">
                            <span class="bm-item-price">&#8377;{{ candidate.item.rate.toFixed(2) }}</span>
                            <span class="bm-item-price-unit">/{{ candidate.item.unit }}</span>
                        </div>
                        <div class="bm-qty-control"
                            *ngIf="!candidate.isAlreadyAdded">
                            <button class="bm-qty-btn"
                                (click)="updateBestMatchQty(candidate, -1)"
                                [disabled]="isDemoPreviewSupplier(candidate.platform) || candidate.quantity <= (candidate.isAlreadyInCart ? 1 : candidate.minimumOrderQty)">&#8722;</button>
                            <span class="bm-qty-val">{{ candidate.quantity }}</span>
                            <button class="bm-qty-btn"
                                (click)="updateBestMatchQty(candidate, 1)"
                                [disabled]="isDemoPreviewSupplier(candidate.platform) || (candidate.item.maximumOrderQty && (candidate.existingCartQty + candidate.quantity) >= candidate.item.maximumOrderQty)">+</button>
                        </div>
                        <span class="bm-item-total"
                            *ngIf="!candidate.isAlreadyAdded">= &#8377;{{ (candidate.item.rate *
                            candidate.quantity).toFixed(2) }}</span>
                    </div>
                </div>
            </div>

            <!-- Footer -->
            <div class="bm-modal-footer">
                <div class="bm-footer-summary">
                    <span class="bm-summary-count">{{ selectedBestMatchCount }} of {{ bestMatchCandidates.length -
                        alreadyAddedBestMatchCount }} pending selected</span>
                    <span class="bm-summary-total">Total: &#8377;{{ bestMatchTotalValue.toFixed(2) }}</span>
                </div>
                <button class="bm-add-all-btn"
                    (click)="addAllBestMatches()"
                    [disabled]="selectedBestMatchCount === 0 || isAddingBestMatches">
                    <div class="btn-loader"
                        *ngIf="isAddingBestMatches">
                        <div class="spinner-small"></div>
                    </div>
                    <ng-container *ngIf="!isAddingBestMatches">
                        <svg width="15"
                            height="15"
                            viewBox="0 0 24 24"
                            fill="none">
                            <path
                                d="M7.4 17C6.84 17 6.4 17.44 6.4 18C6.4 18.56 6.84 19 7.4 19C7.96 19 8.4 18.56 8.4 18C8.4 17.44 7.96 17 7.4 17ZM17.4 17C16.84 17 16.4 17.44 16.4 18C16.4 18.56 16.84 19 17.4 19C17.96 19 18.4 18.56 18.4 18C18.4 17.44 17.96 17 17.4 17Z"
                                fill="currentColor" />
                            <path
                                d="M15.9 14.5L20.8 7.64C20.89 7.47 20.9 7.28 20.9 7.1C20.9 6.55 20.45 6.1 19.9 6.1H6.62L5.68 4.1H2.4V6.1H4.4L8.01 13.68L6.72 16.03C6.49 16.44 6.4 16.92 6.4 17.43C6.4 18.3 7.12 19.03 8 19.03H19.4V17.03H8.42L9.31 14.6L15.9 14.5Z"
                                fill="currentColor" />
                        </svg>
                        Add {{ selectedBestMatchCount }} to Cart
                    </ng-container>
                </button>
            </div>
        </div>

    </div>

    <!-- Settings Popup Modal -->
    <div class="settings-modal-overlay"
        *ngIf="isSettingsPopupOpen"
        (click)="toggleSettingsPopup()">
        <div class="settings-modal"
            (click)="$event.stopPropagation()">
            <div class="modal-header">
                <div class="title-with-icon">
                    <span class="material-icons">settings</span>
                    <h3>Supplier Preferences</h3>
                </div>
                <button class="close-btn"
                    (click)="toggleSettingsPopup()">
                    <span class="material-icons">close</span>
                </button>
            </div>
            <div class="modal-body">
                <p class="subtitle">Drag suppliers to set your preferred order. #1 appears first in search results.</p>

                <div cdkDropList
                    class="supplier-list"
                    (cdkDropListDropped)="onSupplierDrop($event)">
                    <div class="supplier-card"
                        *ngFor="let supplier of tempSupplierOrder; let i = index"
                        cdkDrag
                        [class.preferred-card]="i === 0">
                        <div class="supplier-content">
                            <div class="left-section">
                                <span class="material-icons drag-handle">drag_indicator</span>
                                <span class="index-num"
                                    [class.first-item]="i === 0">{{ i + 1 }}</span>
                                <img *ngIf="getPlatformLogo(supplier.id)"
                                    [src]="getPlatformLogo(supplier.id)"
                                    class="supplier-logo-img"
                                    alt="{{ supplier.name }}">
                                <span *ngIf="!getPlatformLogo(supplier.id)"
                                    class="supplier-name">{{ supplier.name }}</span>
                                <i class="material-icons gold-star"
                                    *ngIf="i === 0">star</i>
                            </div>
                            <div class="right-section"
                                *ngIf="i === 0">
                                <span class="supplier-subtext">Preferred supplier</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Entity Switch Confirmation Modal -->
<div pmdModal
    modalTrap
    #entitySwitchConfirmModal="pmd-modal"
    class="modal pmd-modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="entitySwitchConfirmLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm">
        <div class="modal-content">
            <div class="modal-header m-0 position-absolute end-0"
                style="z-index: 9999;">
                <button aria-hidden="true"
                    aria-label="Close"
                    (click)="cancelEntitySwitch()"
                    class="ms-auto close"
                    type="button">
                    <i class="material-icons-round">close</i>
                </button>
            </div>
            <div class="modal-body text-center">
                <div class="mb-3 pmd-avatar pmd-avatar-warning pmd-avatar-xl d-inline-flex"
                    aria-hidden="true">
                    <span class="material-icons">warning</span>
                </div>
                <h4 id="entitySwitchConfirmLabel"
                    class="h5">
                    Price Discovery in Progress
                </h4>
                <p>Discovery will stop if Entity is switched. Do you want to continue?</p>
            </div>
            <div class="modal-footer justify-content-center mt-2">
                <button type="button"
                    aria-label="Confirm"
                    (click)="confirmEntitySwitch()"
                    pmdRipple
                    pmd-btn-raised
                    color="secondary">
                    Ok
                </button>
                <button type="button"
                    aria-label="Cancel"
                    (click)="cancelEntitySwitch()"
                    pmd-btn-outline
                    pmdRipple
                    color="dark">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>

<!-- HP Recent Purchases Modal -->
<div class="hp-recent-modal-overlay"
  *ngIf="showHpRecentPurchasesModal"
  (click)="toggleHpRecentPurchasesModal()">
  <div class="hp-recent-modal"
    (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="hp-recent-modal-header">
      <div class="hp-recent-modal-title">
        <i class="material-icons" style="color: #e6b401;">local_shipping</i>
        <h3>Recent Purchases</h3>
        <span class="hp-recent-count-badge" *ngIf="hpRecentPurchaseTotalCount > 0">
          {{ hpRecentPurchaseTotalCount }} items
        </span>
      </div>
      <button class="hp-recent-close-btn" (click)="toggleHpRecentPurchasesModal()">
        <i class="material-icons">close</i>
      </button>
    </div>

    <!-- Search Bar -->
    <div class="hp-recent-search">
      <i class="material-icons">search</i>
      <input type="text"
        [(ngModel)]="searchHpRecentPurchaseTerm"
        placeholder="Search items..." />
    </div>

    <!-- Loading State -->
    <div class="hp-recent-loading" *ngIf="isHpRecentPurchasesLoading">
      <div class="pm-spinner"></div>
      <span>Loading Recent Purchases...</span>
    </div>

    <!-- Content -->
    <div class="hp-recent-content" *ngIf="!isHpRecentPurchasesLoading">

      <!-- Live Items Section -->
      <div class="hp-recent-section" *ngIf="filteredHpLiveItems.length > 0">
        <div class="hp-section-header">
          <h4>
            <i class="material-icons" style="color: #4CAF50; font-size: 18px; vertical-align: middle;">check_circle</i>
            Available Items
          </h4>
          <span class="hp-section-count">{{ hpRecentPurchaseLiveCount }} items</span>
        </div>
        <div class="hp-items-grid">
          <div class="hp-item-card"
            *ngFor="let item of filteredHpLiveItems">
            <div class="hp-item-image">
              <img [src]="item.productImages || 'assets/images/placeholder-product.svg'"
                [alt]="item.itemName"
                loading="lazy"
                onerror="this.src='assets/images/placeholder-product.svg'" />
              <span class="hp-stock-badge in-stock" *ngIf="item.isInStock">In Stock</span>
              <span class="hp-stock-badge out-of-stock" *ngIf="!item.isInStock">Out of Stock</span>
            </div>
            <div class="hp-item-body">
              <h5 class="hp-item-name" [title]="item.itemName">{{ item.itemName || item.item_name || item.name }}</h5>
              <p class="hp-item-unit">{{ item.unit }}</p>
              <div class="hp-item-price-row">
                <span class="hp-item-price">₹{{ item.rate?.toFixed(2) || '0.00' }}</span>
                <span class="hp-item-orders" *ngIf="item.orderCount">
                  {{ item.orderCount }} orders
                </span>
              </div>
              <div class="hp-item-actions">
                <button class="hp-search-btn"
                  (click)="searchHpRecentPurchaseItem(item)"
                  title="Search this item">
                  <i class="material-icons" style="font-size: 14px;">search</i>
                  Compare
                </button>
                <div class="hp-qty-controls" *ngIf="item.selectedQuantity > 0">
                  <button class="hp-qty-btn minus" (click)="updateHpQuantity(item, -1)" [disabled]="item.isAddingToCart">
                    <i class="material-icons">remove</i>
                  </button>
                  <span class="hp-qty-val">
                    <i class="material-icons hp-spinner" *ngIf="item.isAddingToCart">refresh</i>
                    <ng-container *ngIf="!item.isAddingToCart">{{ item.selectedQuantity }}</ng-container>
                  </span>
                  <button class="hp-qty-btn plus" (click)="updateHpQuantity(item, 1)" [disabled]="item.isAddingToCart">
                    <i class="material-icons">add</i>
                  </button>
                </div>
                <button class="hp-add-tag-btn"
                  *ngIf="!item.selectedQuantity"
                  (click)="addHpToCart(item)"
                  [disabled]="item.isAddingToCart || !item.isInStock"
                  title="Add to cart">
                  <i class="material-icons hp-spinner" *ngIf="item.isAddingToCart">refresh</i>
                  <i class="material-icons" style="font-size: 18px;" *ngIf="!item.isAddingToCart">add</i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Missing Items Section -->
      <div class="hp-recent-section" *ngIf="filteredHpMissingItems.length > 0">
        <div class="hp-section-header">
          <h4>
            <i class="material-icons" style="color: #f59e0b; font-size: 18px; vertical-align: middle;">error_outline</i>
            Missing Latest Prices
          </h4>
          <span class="hp-section-count missing">{{ hpRecentPurchaseMissingCount }} items</span>
        </div>
        <div class="hp-missing-banner">
          <i class="material-icons">info</i>
          <span>We couldn't fetch the latest prices for these items. You can still search and compare them across suppliers.</span>
        </div>
        <div class="hp-items-grid">
          <div class="hp-item-card hp-item-missing"
            *ngFor="let item of filteredHpMissingItems">
            <div class="hp-item-image">
              <img [src]="item.productImages || 'assets/images/placeholder-product.svg'"
                [alt]="item.itemName"
                loading="lazy"
                onerror="this.src='assets/images/placeholder-product.svg'" />
            </div>
            <div class="hp-item-body">
              <h5 class="hp-item-name" [title]="item.itemName">{{ item.itemName || item.item_name || item.name }}</h5>
              <p class="hp-item-unit">{{ item.unit }}</p>
              <div class="hp-item-price-row">
                <div style="display: flex; flex-direction: column;">
                  <span class="hp-item-last-price-label">Last purchase</span>
                  <span class="hp-item-price muted">₹{{ item.rate?.toFixed(2) || '0.00' }}</span>
                </div>
                <span class="hp-item-orders" *ngIf="item.orderCount">
                  {{ item.orderCount }} orders
                </span>
              </div>
              <div class="hp-item-actions">
                <button class="hp-search-btn"
                  (click)="searchHpRecentPurchaseItem(item)">
                  <i class="material-icons" style="font-size: 14px;">search</i>
                  Compare Prices
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Empty State -->
      <div class="empty-state" *ngIf="filteredHpLiveItems.length === 0 && filteredHpMissingItems.length === 0 && searchHpRecentPurchaseTerm">
        <i class="material-icons">search_off</i>
        <h3>No matching items found</h3>
        <p>Try searching for a different item name.</p>
      </div>

    </div>
  </div>
</div>

<!-- Connect Lead Popup (demo mode) -->
<app-connect-lead-modal></app-connect-lead-modal>

<!-- Inventory PR Modal -->
<app-inventory-pr-modal
  [isVisible]="showInventoryPrModal"
  [entityId]="selectedEntityId"
  [searchTags]="searchItems"
  (closeModal)="showInventoryPrModal = false"
  (searchItems)="handleInventoryPrSearch($event)">
</app-inventory-pr-modal>